import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function Job() {
  const [submissions, setSubmissions] = useState([]);

  // Fetch submissions from API
  useEffect(() => {
    fetchSubmissions();
  }, []);

  const fetchSubmissions = async () => {
    try {
      const response = await axios.get(
        "https://ma-laravel.ma-uae.com/api/form-submissions"
      );
      setSubmissions(response.data);

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch submissions. Please try again.",
      });
    }
  };

  // Handle delete with SweetAlert2
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will delete the submission permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Close",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
          `https://ma-laravel.ma-uae.com/api/form-submissions/${id}`
        );
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Submission deleted successfully!",
        });
        fetchSubmissions();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete submission. Please try again.",
        });
      }
    }
  };

  return (
    <section className="p-6">
      <h1 className="text-2xl font-bold mb-4">Job Applications</h1>

      {/* Submissions Table */}
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 p-2">Full Name</th>
            <th className="border border-gray-300 p-2">Email</th>
            <th className="border border-gray-300 p-2">Country</th>
            <th className="border border-gray-300 p-2">Governorate/Emirate</th>
            <th className="border border-gray-300 p-2">Phone Number</th>
            <th className="border border-gray-300 p-2">Experience</th>
            <th className="border border-gray-300 p-2">Position</th>
            <th className="border border-gray-300 p-2">CV</th>
            <th className="border border-gray-300 p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {submissions.map((submission) => (
            <tr key={submission.id}>
              <td className="border border-gray-300 p-2">
                {submission.full_name}
              </td>
              <td className="border border-gray-300 p-2">{submission.email}</td>
              <td className="border border-gray-300 p-2">
                {submission.country}
              </td>
              <td className="border border-gray-300 p-2">
                {submission.governorate_emirate}
              </td>
              <td className="border border-gray-300 p-2">
                {submission.phone_number}
              </td>
              <td className="border border-gray-300 p-2">
                {submission.experience}
              </td>
              <td className="border border-gray-300 p-2">
                {submission.position}
              </td>
              <td className="border border-gray-300 p-2">
                <a
                  href={`https://ma-laravel.ma-uae.com/storage/app/public/${submission.cv_path}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline"
                >
                  View CV
                </a>
              </td>
              <td className="border border-gray-300 p-2">
                <button
                  className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                  onClick={() => handleDelete(submission.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
